import React, { useEffect, useState, useRef } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import Aside from "./Aside";
import { Link } from "react-router-dom";
import CampoNit from "../custom/CampoNit";
import { escalarImagen } from "../../../resources/Helper";

function CuentaForm() {
    
    const [id, setId] = useState('');
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [numColaboradores, setNumColaboradores] = useState('5');
    const [direccion, setDireccion] = useState('');
    const [tipoEmpresa, setTipoEmpresa] = useState('2');
    const [pais, setPais] = useState('Colombia');
    const [telefono, setTelefono] = useState('');
    const [identificacion, setIdentificacion] = useState('');
    const [tipoIdentificacion, setTipoIdentificacion] = useState('');
    const [plan, setPlan] = useState('');
    const [digitoVerificacion, setDigitoVerificacion] = useState();
    const [logo, setLogo] = useState();
    const [logoData, setLogodata] = useState();
    
    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();
    const [client, setClient] = useState([]);
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');

    const [mensajePopup, setMensajePopup] = useState('Lorem ipsum dolor');
    const [claseMensajePopup, setClaseMensajePopup] = useState('alert alert-success mensaje-popup');

    const [headerCollapsed, setHeadercollapsed] = useState('collapse-hdr');
    let userdata = [];
    let history = useHistory();

    const [showToast, setShowToast] = useState(false);
    const [toastDelay, setToastDelay] = useState(4000);
    const [toastMessage, setToastMessage] = useState();

    const logoRef = useRef(0);
    const canvasRef = useRef(0);

    useEffect(() => {
      
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setId(response.data.client_id);
                    setNombreEmpresa(response.data.nombre);
                    setNumColaboradores(response.data.empleados);
                    setDireccion(response.data.direccion);
                    setTipoEmpresa(response.data.tipo_cliente);
                    setPais(response.data.pais);
                    setTelefono(response.data.telefono);
                    setIdentificacion(response.data.numero_documento);
                    setTipoIdentificacion(response.data.tipo_documento);
                    setPlan(response.data.plan);
                    setDigitoVerificacion(response.data.digito_verificacion);
                    setLogo(response.data.logo);

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
    },[]);


    useEffect(() => {
        renderLogo();
    },[logo]);


    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            nombre: nombreEmpresa,
            empleados: numColaboradores,
            direccion: direccion,
            tipo_cliente: tipoEmpresa,
            pais: pais,
            telefono: telefono,
            numero_documento: identificacion,
            tipo_documento: tipoIdentificacion,
            id: id,
            digito_verificacion: digitoVerificacion,
            logo: logo
        };


        axios.put('client', conf)
            .then(
                response => {
                    setErrorlist({});
                    setLoading(false);
                    setToastMessage('La Información De La Cuenta Ha Sido Modificada');
                    setToastDelay(4000);
                    setShowToast(true);
                }
            )
            .catch(
                err => {
                    console.log(err.response.data)

                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    function handleNit(valor, digitoVerificacion) {
        setIdentificacion(valor);
        setDigitoVerificacion(digitoVerificacion);
    }


    const agregarLogo = (files) => {

        let file = files[0];
        if (!file) {
            return;
        }

        if (file.size > (2 * 1024 * 1024)) {
            setErrorlist((prev) => ({ ...prev, logo: 'La imagen supera el tamaño permitido (2MB).' }));
            return;
        }

        if (!['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)) {
            setErrorlist((prev) => ({ ...prev, logo: 'Formato de imagen no soportado.' }));
            return;
        }

        setErrorlist((prev) => ({ ...prev, logo: undefined }));
        const f = URL.createObjectURL(file);
        
        var ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const img = new Image();

        img.onload = function() {
            const imgWidth = img.width;
            const imgHeight = img.height;

            const newWidth = canvasRef.current.width;

            const imagenEscalada = escalarImagen(img.width, img.height, canvasRef.current.width, canvasRef.current.height);
            const coordX = Math.floor((canvasRef.current.width - imagenEscalada.ancho)/2);
            const coordY = Math.floor((canvasRef.current.height - imagenEscalada.alto)/2);
            ctx.drawImage(img, coordX, coordY, imagenEscalada.ancho, imagenEscalada.alto);
            //setLogo(canvasRef.current.toDataURL("image/png"));
            setLogo(canvasRef.current.toDataURL());
        }

        img.src = f;
    }


    const renderLogo = () => {

        var ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const img = new Image();

        img.onload = function() {
            const imgWidth = img.width;
            const imgHeight = img.height;

            const newWidth = canvasRef.current.width;

            const imagenEscalada = escalarImagen(img.width, img.height, canvasRef.current.width, canvasRef.current.height);
            const coordX = Math.floor((canvasRef.current.width - imagenEscalada.ancho)/2);
            const coordY = Math.floor((canvasRef.current.height - imagenEscalada.alto)/2);
            ctx.drawImage(img, coordX, coordY, imagenEscalada.ancho, imagenEscalada.alto);
        }

        img.src = logo;
    }



    return (
      <div className="hold-transition">
        <Header client={client} />
        <Aside client={client} activelink="settings" />
        
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-8">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item" key="k0"><Link to="/home">Home</Link></li>
                                <li className="breadcrumb-item" key="k1"><Link to="/settings">Configuración</Link></li>
                                <li className="breadcrumb-item" key="k2">Cuenta De Usuario</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-8">
                            <h1 className="m-0">Configurar Empresa / Profesional Independiente</h1>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content" >
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-11">
                            <style>{`
                                .cuenta-tabs-wrap { margin-bottom: 0; }
                                .cuenta-tabs.nav-tabs {
                                    border-bottom: 1px solid #e8ecef;
                                    gap: 8px;
                                    flex-wrap: wrap;
                                }
                                .cuenta-tabs .nav-item { margin-bottom: -1px; }
                                /* Anula custom.css (.nav-link:hover con fondo oscuro y !important) */
                                .cuenta-tabs .nav-link {
                                    cursor: pointer;
                                    border: 1px solid #e8ecef;
                                    border-radius: 12px 12px 0 0;
                                    color: #495057 !important;
                                    background-color: #f8f9fa !important;
                                    padding: 12px 20px;
                                    font-weight: 600;
                                    font-size: 0.95rem;
                                    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
                                    font-family: inherit;
                                    line-height: 1.35;
                                    margin: 0;
                                    box-shadow: none !important;
                                }
                                .cuenta-tabs .nav-link i {
                                    color: #495057 !important;
                                    opacity: 0.9;
                                }
                                .cuenta-tabs button.nav-link:focus {
                                    outline: none;
                                    box-shadow: 0 0 0 2px rgba(23, 162, 184, 0.25) !important;
                                }
                                .cuenta-tabs .nav-link:hover,
                                .cuenta-tabs .nav-link:focus-visible {
                                    color: #117a8b !important;
                                    background-color: #f1f5f9 !important;
                                    border-color: #dee2e6 !important;
                                    box-shadow: none !important;
                                }
                                .cuenta-tabs .nav-link:hover i,
                                .cuenta-tabs .nav-link:focus-visible i {
                                    color: #117a8b !important;
                                }
                                .cuenta-tabs .nav-link.active {
                                    color: #0d5c6b !important;
                                    background-color: #fff !important;
                                    border-color: #e8ecef #e8ecef #fff !important;
                                    border-bottom: 1px solid #fff !important;
                                    box-shadow: 0 -2px 0 #17a2b8 inset !important;
                                }
                                .cuenta-tabs .nav-link.active i {
                                    color: #0d5c6b !important;
                                }
                                .cuenta-tabs .nav-link.active:hover,
                                .cuenta-tabs .nav-link.active:focus-visible {
                                    color: #0d5c6b !important;
                                    background-color: #fff !important;
                                    border-color: #e8ecef #e8ecef #fff !important;
                                    box-shadow: 0 -2px 0 #17a2b8 inset !important;
                                }
                                .cuenta-tabs .nav-link.active:hover i,
                                .cuenta-tabs .nav-link.active:focus-visible i {
                                    color: #0d5c6b !important;
                                }
                                .horarios-info-banner,
                                .horarios-ejemplo-tip {
                                    font-size: 1rem;
                                    line-height: 1.55;
                                }
                                .horarios-info-banner {
                                    border-radius: 10px;
                                    padding: 0.85rem 1.1rem;
                                }
                                .horarios-info-banner i {
                                    font-size: 1em;
                                    vertical-align: -0.06em;
                                }
                                .horarios-ejemplo-tip {
                                    margin-bottom: 0;
                                    padding: 0.85rem 1.1rem;
                                    border-radius: 10px;
                                    background-color: #fdf8f1 !important;
                                    border: 1px solid #ebe3d6 !important;
                                    color: #5a5349 !important;
                                    box-shadow: none;
                                }
                                .horarios-ejemplo-tip strong {
                                    color: #454038;
                                    font-weight: 600;
                                }
                            `}</style>

                            <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                                <div className="card">
                                    <div id="infobasica">
                                        <div className="card-body">

                                            
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Nombre / Razon Social</label>
                                                            <input type="text" name="company-name" className="form-control" id="companyName" defaultValue={nombreEmpresa} onChange={(e) => setNombreEmpresa(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.nombre}
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="companyAddress">Dirección</label>
                                                            <input type="text" name="company-address" className="form-control" id="companyAddress" defaultValue={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.direccion}
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="tipoIdentificacion">Tipo Documento</label>
                                                            <select name="tipoIdentificacion" id="tipoIdentificacion" className="form-control" value={tipoIdentificacion} onChange={(e) => setTipoIdentificacion(e.target.value)}>
                                                                <option value="NIT">NIT</option>
                                                                <option value="CC">CC</option>
                                                                <option value="TI">TI</option>
                                                                <option value="CE">CE</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="companyType">Tipo De Empresa</label>
                                                            <select name="company-type" className="form-control" id="companyType" value={tipoEmpresa} onChange={(e) => setTipoEmpresa(e.target.value)}>
                                                                <option value="1">Consultorio Medico</option>
                                                                <option value="2">Consultorio Odontológico</option>
                                                                <option value="3">Clínica Estetica</option>
                                                                <option value="4">Clínica Dermatologica</option>
                                                                <option value="5">Centro De Vacunacion</option>
                                                                <option value="6">SPA</option>
                                                                <option value="4">Otro</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="country">País</label>
                                                            <select name="country" className="form-control" id="country" value={pais} onChange={(e) => setPais(e.target.value)}>
                                                                <option value="Colombia">Colombia</option>
                                                                <option value="Ecuador">Ecuador</option>
                                                                <option value="Peru">Perú</option>
                                                                <option value="Panama">Panamá</option>
                                                                <option value="Otro">Otro</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="phoneNumber">Número Celular</label>
                                                            <input type="text" name="phone-number" className="form-control" id="phoneNumber" placeholder="Número telefónico" defaultValue={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.telefono}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <CampoNit valor={identificacion} digitoVerificacion={digitoVerificacion} onChange={handleNit} />
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="tipoIdentificacion">Logo De La Empresa</label>
                                                            
                                                            <div className="contenedor-logo-cliente">
                                                                <div className="contenedor-imagen-logo">
                                                                    <canvas id="myCanvas" className="logo-cliente" width="240" height="180" ref={canvasRef}>
                                                                    </canvas>
                                                                    <input type="file" name="logoimg" id="logoimg" className="form-control logo-cliente-control" accept=".jpg, .png, .jpeg" onChange={(e) => agregarLogo(e.target.files)} />
                                                                </div>
                                                                <label htmlFor="logoimg" className="lbl-cargar-foto-perfil">Cargar Imagen</label>
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.logo}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{marginTop: '30px'}}>
                                    <div className="col-md-6">
                                        <button type="submit" className="btn btn-primary">
                                            Guardar Cambios&nbsp;
                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            
                                        </button>
                                    </div>
                                </div>

                            </form>

                        </div>          
                    </div>

                </div>
            </section>
            
        </div>
        
        <div className={claseMensajePopup}>{mensajePopup}</div>

        <Footer showToast={showToast} delay={toastDelay} message={toastMessage} />
      </div>
    );
}
export default CuentaForm;